export default __webpack_public_path__ + "static/media/rehack-22.3483d70c.jpg";